// Perpetual prices and token sizes are 18-decimal integers on-chain (verified:
// backend reports quote_decimals=18 for perps on both Arc and Monad — this is
// the perp price scale, independent of the USDC *settlement* token's decimals).
//
// The live WebSocket feed (streamer-engine) forwards these values RAW
// ("Forward raw 18-decimal integer … the frontend converts raw → display"),
// and so do SOME REST endpoints. Which ones is not a blanket rule and has
// caused real bugs: `GET /orderbook` returns raw 1e18 integers (verified
// against the live API — bids like "76805100000000000000000"), even though
// ticker/statistics values on the same API arrive already scaled. Check the
// endpoint rather than assuming "REST is scaled".
//
// Without normalizing, a live WS tick overwrites a correctly-scaled REST value
// with the raw integer — so the price/OI "loses its decimal" until the page is
// refreshed.
//
// This normalizes a raw 18-dec value to display units. It is GUARDED so an
// already-scaled value is never double-divided: display prices/sizes are far
// below 1e12, whereas raw 18-dec values are far above it.
export const PERP_PRICE_DECIMALS = 18;

export const displayFromRaw18 = (
  value?: string | number | null
): string | number | undefined | null => {
  if (value === undefined || value === null || value === "") return value;
  const s = String(value).trim();
  // Already in display form (has a fractional part or exponent) — leave it.
  if (s.includes(".") || s.includes("e") || s.includes("E")) return value;
  const n = Number(s);
  if (!Number.isFinite(n)) return value;
  // Raw 18-dec on-chain integers are >> 1e12; real display prices/sizes are <<.
  return n >= 1e12 ? n / 10 ** PERP_PRICE_DECIMALS : value;
};
